import { mapActions, mapGetters } from 'vuex';
import Server from "@/assets/js/servers.js";
export default {
    data(){
        return {
            active: 0,
            detail: '',
            isFull: false
        }
    },
    created(){
        //获取栏目列表
        this.getCommonColumns(()=>{
            this.initRouteActive();
        });
    },
    methods:{
        //栏目点击
        tabClick(index){
            let link = this.columns[index].route_name;
            this.$router.push({
                name: link
            });
        },
        initRouteActive(){
            let routeName = this.$route.name;
            this.columns.forEach((item,index) => {
                if(item.route_name == routeName){
                    this.isFull = item.is_full_screen == 1;
                    this.active = index;
                    this.getColumnDetail(index);
                }
            });
        },
        //获取详情
        getColumnDetail(index){
            let name = this.columns[index].menu_name;
            this.$http.get(Server.detail+"?menu_name="+name).then(res => {
                if(res.code == 0){
                    this.detail = res.data[0].menu_content;
                }
            }).catch(e => {
                console.log(e);
            });
        },
        ...mapActions(['getCommonColumns'])
    },
    computed:{
        ...mapGetters(['columns'])
    }
}



// WEBPACK FOOTER //
// ./src/assets/mixins/normalMixins.js